import actionTypes from '../actions/terms-of-use.action-types';

export default (state = {}, action) => {
  switch (action.type) {
    case actionTypes.FETCH_TERMS_OF_USE_SUCCESS:
      return { ...action.content.attachments };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/modules/utils/rw-terms-of-use/components/reducers/terms-of-use-attachments.js